import React from "react";
import { useDispatch } from "react-redux";
import { useFormikContext } from "formik";
import { FormErrorModal } from "./formErrorModal";

export const FormErrorHandler = ({ actions, loanFormError }) => {
  const dispatch = useDispatch();
  const { handleReset } = useFormikContext();

  const onModalClose = () => dispatch(actions.clearError());
  const onModalRestart = () => {
    dispatch(actions.resetForm());
    handleReset();
  };

  return (
    <FormErrorModal visible={loanFormError} close={onModalClose} restart={onModalRestart} />
  );
};